var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgArrowUp = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  fillRule: "evenodd",
  d: "M11.85.796c-.326.044-.132-.134-3.218 2.946a291 291 0 0 0-2.92 2.936c-.143.176-.2.35-.2.606 0 .167.013.248.055.356.106.275.37.52.652.605a1.1 1.1 0 0 0 .693-.049c.147-.065.263-.175 2.118-2.026l1.962-1.957v9.012c0 5.733.009 9.063.024 9.154.05.312.271.599.568.74.152.072.182.077.416.077s.264-.006.415-.078c.297-.14.518-.427.57-.74.014-.09.023-3.42.023-9.153V4.213L14.97 6.17c1.853 1.85 1.97 1.961 2.118 2.026.205.09.506.11.7.047.477-.157.78-.638.697-1.11-.062-.347.132-.136-2.99-3.264C13.921 2.294 12.587.973 12.528.934a1 1 0 0 0-.678-.138",
  clipRule: "evenodd"
})));
export default SvgArrowUp;